import { render, staticRenderFns } from "./SubsExport.vue?vue&type=template&id=945086bc&scoped=true"
import script from "./SubsExport.vue?vue&type=script&lang=js"
export * from "./SubsExport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "945086bc",
  null
  
)

export default component.exports